import { AppError } from "@/shared/AppError";

export function parseBackendError(err: any): AppError {
  const backendData = err.response?.data || {};
  return new AppError({
    code: backendData.errorCode || "UNKNOWN_ERROR",
    internalMessage: backendData.message || "No backend message",
    uiMessage:
      backendData.uiMessage ||
      backendData.message ||
      "Etwas ist schief gelaufen.",
    translations: backendData.translations,
    isExpected: backendData.status === "error",
  });
}
